module.exports = {
  en: {
    'vux.actionsheet.cancel': 'cancel',
    'vux.alert.button_text': 'OK',
    'vux.calendar.cancel_text': 'cancel',
    'vux.calendar.confirm_text': 'done',
    'vux.confirm.confirm_text': 'confirm',
    'vux.confirm.cancel_text': 'cancel',
    'vux.datetime.cancel_text': 'cancel',
    'vux.datetime.confirm_text': 'done',
    'vux.inline-calendar.week_day_0': 'Su',
    'vux.inline-calendar.week_day_1': 'Mo',
    'vux.inline-calendar.week_day_2': 'Tu',
    'vux.inline-calendar.week_day_3': 'We',
    'vux.inline-calendar.week_day_4': 'Th',
    'vux.inline-calendar.week_day_5': 'Fr',
    'vux.inline-calendar.week_day_6': 'Sa',
    'vux.loading.loading': 'loading',
    'vux.popup-picker.cancel_text': 'cancel',
    'vux.popup-picker.confirm_text': 'ok',
    'vux.search.cancel_text': 'cancel',
    'vux.search.placeholder': 'Search',
    'vux.x-header.back_text': 'Back'
  },
  'zh-CN': {
    'vux.actionsheet.cancel': '取消',
    'vux.alert.button_text': '确定',
    'vux.calendar.cancel_text': '取消',
    'vux.calendar.confirm_text': '确定',
    'vux.confirm.confirm_text': '确定',
    'vux.confirm.cancel_text': '取消',
    'vux.datetime.cancel_text': '取消',
    'vux.datetime.confirm_text': '确定',
    'vux.inline-calendar.week_day_0': '日',
    'vux.inline-calendar.week_day_1': '一',
    'vux.inline-calendar.week_day_2': '二',
    'vux.inline-calendar.week_day_3': '三',
    'vux.inline-calendar.week_day_4': '四',
    'vux.inline-calendar.week_day_5': '五',
    'vux.inline-calendar.week_day_6': '六',
    'vux.loading.loading': '加载中',
    'vux.popup-picker.cancel_text': '取消',
    'vux.popup-picker.confirm_text': '完成',
    'vux.search.cancel_text': '取消',
    'vux.search.placeholder': '搜索',
    'vux.x-header.back_text': '返回',
    'Focuslight Bidding': '炬光采购竞价',
    'Focuslight Tip': '炬光提示',
    Login: '登录',
    'Register Now': '立即注册',
    'Forgot Password': '忘记密码',
    'Send Code': '发送验证码',
    'Enter phone number': '请输入手机号',
    'Enter email': '请输入邮箱',
    'Enter Login Password': '请输入登录密码',
    'Enter Confirm Password': '确认登录密码',
    'Enter verification code': '请输入验证码',
    'China user': '中国用户',
    'Email user': '邮箱用户',
    'Chinese mobile': '中国手机',
    'Account user': '账号用户',
    'Other country user': '国外用户',
    'Do I have an account?': '我有账号?',
    'Go Login': '去登录',
    Logout: '退出登录',
    'Enter Supplier Name': '请输入供应商名称',
    'Please enter your account name': '请输入账户名称',
    'Enter Contact Name': '请输入联系人姓名',
    'Registering...': '正在注册...',
    'Sending...': '正在发送...',
    'Logging...': '正在登录...',
    'Entering...': '正在录入...',
    'Upload...': '正在上传...',
    'Saving...': '正在上传...',
    'Login success': '登录成功',
    'Please contact the system administrator to reset your password': '请联系系统管理员修改密码',
    'Email channel temporarily unavailable': '邮箱渠道暂停使用',
    day: '天',
    hour: '时',
    minute: '分',
    second: '秒',
    'My Bids': '我的竞标',
    'See All Bids': '查看全部竞标',
    'More Notifications': '更多通知',
    Notifications: '通知',
    'Notification Details': '通知详情',
    'Not Started': '未开始',
    'In Progress': '进行中',
    Completed: '已结束',
    Abandoned: '已弃标',
    'Loading...': '加载中...',
    'Focuslight New Notification': '炬光新通知',
    Cancel: '取消',
    'Check Now': '立即查看',
    Tip: '提示',
    'Confirm logout?': '您确定要退出登录吗？',
    'My Notifications': '我的通知',
    'Refresh List': '刷新列表',
    Unread: '未读',
    Read: '已读',
    'View Details': '查看详情',
    'Load More': '加载更多',
    'No More': '没有更多了',
    'No Data': '暂无数据',
    All: '全部',
    'Bid Details': '标的详情',
    'Bid Info': '标的信息',
    'My Rank': '我的排名',
    Rank: '排名',
    Supplier: '供应商',
    Price: '价格',
    'My Bid Note': '我的竞标备注',
    'My Bid': '我的报价',
    'Bid Category': '竞标类别',
    Unit: '单位',
    Delete: '删除',
    'Delete Attachment': '删除附件',
    'Start Time': '开始时间',
    'End Time': '结束时间',
    'Price Reduction Rate': '降价幅度',
    'Last Minute Reduction Rate': '最后一分钟降价幅度',
    'Custom Reduction Base': '自定义降幅基数',
    Remarks: '备注',
    'Maximum Price': '最高限价',
    'Minimum Price': '最低限价',
    'Custom Reduction Rate Must Be Integer Multiple of Base': '自定义降价幅度应为基数整数倍数',
    'Initial Bidding Price': '首次竞标价格',
    'My Attachments': '我的附件',
    'Focuslight Attachments': '炬光附件',
    'Upload Attachment': '上传附件',
    'Please enter your bidding remarks': '请输入您的竞价备注信息',
    'Save bidding remarks': '保存竞价备注信息',
    'Initial Price Not Entered': '未录入',
    Download: '下载',
    'Discount Now': '立即降价',
    'Custom Price': '自定义价格',
    'Calculating results, please wait...': '系统正在计算竞选结果，请稍等......',
    'Auction Ended.': '竞价结束。',
    'Enter Initial Bid Price': '请输入首次竞标价格',
    'You cancelled the initial entry': '您取消了首次录入',
    'Entry Successful': '录入成功',
    'Quote Now': '立即报价',
    'Last Quote': '上次报价',
    'This Quote': '本次报价',
    'Are you sure to quote?': '您确定要报价吗？',
    'Enter bidding price': '请输入竞标价格',
    'Enter custom bidding price': '请输入自定义竞标价格',
    'Price reduced successfully': '降价成功',
    'Saved successfully': '保存成功',
    'Upload up to 1 attachment': '最多上传1个附件',
    'Bidding Entity': '发标单位',
    'Unfortunately, lost the auction.': '很遗憾，您没有赢得本次竞价。',
    'Thank you for bidding. Final result will be notified by the bidder in writing.': '感谢您参与本次竞价，竞选结果请以发标单位书面通知为准。'
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/locales/all.yml
// module id = jp+n
// module chunks = 12